/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Limit_ReachedInputs */

const en_common_limit_reached = /** @type {(inputs: Common_Limit_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limit reached`)
};

const de_common_limit_reached = /** @type {(inputs: Common_Limit_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limit erreicht`)
};

const fr_common_limit_reached = /** @type {(inputs: Common_Limit_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite atteinte`)
};

const es_common_limit_reached = /** @type {(inputs: Common_Limit_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límite alcanzado`)
};

const it_common_limit_reached = /** @type {(inputs: Common_Limit_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite raggiunto`)
};

const nl_common_limit_reached = /** @type {(inputs: Common_Limit_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limiet bereikt`)
};

const pl_common_limit_reached = /** @type {(inputs: Common_Limit_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osiągnięto limit`)
};

const fi_common_limit_reached = /** @type {(inputs: Common_Limit_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raja saavutettu`)
};

const da_common_limit_reached = /** @type {(inputs: Common_Limit_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grænse nået`)
};

const sv_common_limit_reached = /** @type {(inputs: Common_Limit_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gräns nådd`)
};

/**
* | output |
* | --- |
* | "Limit reached" |
*
* @param {Common_Limit_ReachedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_limit_reached = /** @type {((inputs?: Common_Limit_ReachedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Limit_ReachedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_limit_reached(inputs)
	if (locale === "fr") return fr_common_limit_reached(inputs)
	if (locale === "es") return es_common_limit_reached(inputs)
	if (locale === "it") return it_common_limit_reached(inputs)
	if (locale === "nl") return nl_common_limit_reached(inputs)
	if (locale === "pl") return pl_common_limit_reached(inputs)
	if (locale === "fi") return fi_common_limit_reached(inputs)
	if (locale === "da") return da_common_limit_reached(inputs)
	if (locale === "sv") return sv_common_limit_reached(inputs)
	return en_common_limit_reached(inputs)
});